"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _slicedToArray = function _slicedToArray(e, t) {
  if (Array.isArray(e)) return e;
  if (Symbol.iterator in Object(e)) return function (e, t) {
    var r = [],
        n = !0,
        o = !1,
        a = void 0;

    try {
      for (var l, i = e[Symbol.iterator](); !(n = (l = i.next()).done) && (r.push(l.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, a = e;
    } finally {
      try {
        !n && i.return && i.return();
      } finally {
        if (o) throw a;
      }
    }

    return r;
  }(e, t);
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
},
    _createClass = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}(),
    _reactLeaflet = require("react-leaflet"),
    _leaflet = require("leaflet"),
    _leaflet2 = _interopRequireDefault(_leaflet);

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

function _objectWithoutProperties(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

require("leaflet.markercluster");

var MarkerClusterGroup = function (e) {
  function t() {
    return _classCallCheck(this, t), _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return _inherits(t, _reactLeaflet.MapLayer), _createClass(t, [{
    key: "createLeafletElement",
    value: function value(e) {
      e.children, e.leaflet;

      var t = _objectWithoutProperties(e, ["children", "leaflet"]),
          o = {},
          a = {};

      Object.entries(t).forEach(function (e) {
        var t = _slicedToArray(e, 2),
            r = t[0],
            n = t[1];

        return r.includes("on") ? a[r] = n : o[r] = n;
      });
      var l = new _leaflet2.default.markerClusterGroup(o);
      return this.contextValue = {
        layerContainer: l
      }, Object.entries(a).forEach(function (e) {
        var t = _slicedToArray(e, 2),
            r = t[0],
            n = t[1],
            o = "cluster" + r.substring(2).toLowerCase();

        l.on(o, n);
      }), l;
    }
  }]), t;
}();

exports.default = (0, _reactLeaflet.withLeaflet)(MarkerClusterGroup);